import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Typography, Button, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import apis from '@src/apis';
import actions from '@src/redux/actions';
import logo from '@src/assets/logo/logo-AiVoice-new.svg';
import { StyledDialog } from './index.style';

const ServiceTerm = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [showNote, setShowNote] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const dispatch = useDispatch();

  const handleAgreedToTerm = async () => {
    if (!isChecked) {
      setShowNote(true);
      return;
    }
    setShowNote(false);
    await apis.user.agreeToTerms();
    onClose();
    dispatch(actions.layout.setShowOnboardingTasks(true));
    dispatch(actions.layout.setShowCompleteTaskSurveyDialog(true));
  };

  return (
    <StyledDialog open={open}>
      <div className="dialog-wrapper">
        <div className="logo">
          <img src={logo} alt="vbee tts logo" className="logo-img" />
        </div>
        <Typography className="new-dialog-title">
          {t('serviceTermTitleNew')}
        </Typography>
        <div
          className="dialog-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('serviceTermContentNew'),
          }}
        />
        <div className="dialog-checkbox">
          <Checkbox
            className="checkbox"
            checked={isChecked}
            onChange={() => {
              setShowNote(isChecked);
              setIsChecked(!isChecked);
            }}
          />
          <div>
            <div
              className="text-checkbox-content"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: t('agreeToTermContentNew'),
              }}
            />
            <Typography
              className={`${
                showNote
                  ? 'show-text-checkbox-note'
                  : 'not-show-text-checkbox-note'
              }`}
            >
              {t('agreeToTermsNoteNew')}
            </Typography>
          </div>
        </div>
        <div className="dialog-action">
          <Button
            className="button-agree-policy"
            variant="contained"
            color="primary"
            onClick={handleAgreedToTerm}
            disabled={!isChecked}
          >
            {t('agreeTerm')}
          </Button>
        </div>
      </div>
    </StyledDialog>
  );
};

export default ServiceTerm;
